var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLendRepaid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0EF1BC",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m24.441 10.61-1.072.45a8.17 8.17 0 0 1-4.756.48l-1.462-.29a4.51 4.51 0 0 1-2.84-1.87v0m10.13-4.445-.13.031a6.901 6.901 0 0 1-4.302-.344v0a6.901 6.901 0 0 0-2.673-.539h-.17a7.745 7.745 0 0 0-4.28 1.291l-4.78 3.17a1.222 1.222 0 0 0-.547 1.019v0c0 .602.439 1.115 1.034 1.207l.399.063c.253.04.513.02.758-.054l4.562-1.4m0 0 4.415-1.323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0BC196",
    strokeWidth: 2,
    d: "M21 21a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A0F7E6",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M16 19.25v4.333m-2.167-2.166h4.334"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLendRepaid);
export default __webpack_public_path__ + "static/media/lendRepaid.51d1f56c7b0c677f3631995ffcd86fa6.svg";
export { ForwardRef as ReactComponent };